import {
	IconArrowRightFromLineOutline18 as ArrowRightFromLine,
	IconCheckDoubleOutline18 as CheckDouble,
	IconUserOutline18 as User,
} from "nucleo-ui-outline-18"

import type { TimelineEventProps } from "./types"
import { SystemEvent } from "./base/system-event"
import { parseLiveChatSystemMessage } from "./live-chat-system-message"

const ICON_CLASS = "h-3 min-h-3 w-3 min-w-3 flex-none text-secondary"

export function LiveChatSystemEvent({
	event,
	hasEventAbove = false,
	hasEventBelow = false,
}: TimelineEventProps) {
	if (event.type !== "live-chat-message") {
		return null
	}

	const message = event.liveChatMessage
	if (message.role !== "SYSTEM") {
		return null
	}

	const parsed = parseLiveChatSystemMessage(message.content)

	const icon =
		parsed.kind === "joined" ? (
			<User className={ICON_CLASS} />
		) : parsed.kind === "ended" ? (
			<ArrowRightFromLine className={ICON_CLASS} />
		) : (
			<CheckDouble className={ICON_CLASS} />
		)

	return (
		<SystemEvent
			icon={icon}
			timestamp={message.createdAt ? new Date(message.createdAt) : undefined}
			hasEventAbove={hasEventAbove}
			hasEventBelow={hasEventBelow}
		>
			{parsed.kind === "notice" ? (
				<span className="truncate text-tertiary" title={parsed.text}>
					{parsed.text}
				</span>
			) : (
				<>
					<span className="truncate font-medium text-secondary">
						{parsed.name}
					</span>
					<span className="min-h-full flex-nowrap text-secondary">
						{parsed.kind === "joined" ? "joined" : "ended the conversation"}
					</span>
				</>
			)}
		</SystemEvent>
	)
}
